// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.percentNumber{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.percentNumber p{
    font-size: 10px;
}

.Packing-order{
    display: flex;
    width: 100%;
    margin-bottom: 1%;
}

.Packing-order h2{
    font-size: 15px;
}



.zero{
    font-size: 60px;
    margin-left: 20px;
}

.num{
    display: grid;
    grid-template-columns: 5fr 1fr;
    place-items: center;
    width: 100%;
    margin-top: 10px;
}

.num2{
    display: grid;
    grid-template-columns: 5fr 1fr;
    place-items: center;
    width: 100%;
}

.ri-icon{
    font-size: 30px;
}

.iconPara p{
    font-size: 12px;
    margin-bottom: -2px;
}

.iconPara{
    margin-top: 30px;
}

.iconPara2{
    margin-top: 0px;
}

.empty{
    width: 100%;
    height: 10px;
    border-radius: 10px;
    background-color: #3C4554;
    margin-top: 2%;
}

.missed{
    background-color: #3C4554;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    padding: 0 10px;
    margin-top: 5%;
    border-radius: 10px;
}

.area-top2{
    width: 100%;
    height: 100%;
    margin: auto;
    margin-top: 8px;
    background-color: #3C4554;
    border-radius: 10px;
}

.missed p{
    margin-top: 4%;
}

.iconPara2 p{
    margin-bottom: -2px;
}

.area-top{
    width: 100%;
    height: 100%;
    margin: auto;
    margin-top: 20px;
    background-color: #3C4554;
    border-radius: 10px;
}

.area-bottom{
    display: flex;
    justify-content: space-around;
    margin-top: 2%;
}

.len{
    margin-top: 2%;
    width: 100%;
    height: 100px;
}

.btn-col{
    background-color: #636C7B;
}


.LookUp{
    margin-right: 20px;
    font-size: 20px;
}




.goloc{
    font-size: 13px;
    margin-top: -5px;
}


.goloc2{
    font-size: 12.5px;
    margin-top: -4px;
}

.goloc3{
    font-size: 20px;
}

.zero1{
    font-size: 40px;
}`, "",{"version":3,"sources":["webpack://./src/css/Packing.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;;;AAIA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,kBAAkB;IAClB,eAAe;AACnB;;;;;AAKA;IACI,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".percentNumber{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.percentNumber p{\n    font-size: 10px;\n}\n\n.Packing-order{\n    display: flex;\n    width: 100%;\n    margin-bottom: 1%;\n}\n\n.Packing-order h2{\n    font-size: 15px;\n}\n\n\n\n.zero{\n    font-size: 60px;\n    margin-left: 20px;\n}\n\n.num{\n    display: grid;\n    grid-template-columns: 5fr 1fr;\n    place-items: center;\n    width: 100%;\n    margin-top: 10px;\n}\n\n.num2{\n    display: grid;\n    grid-template-columns: 5fr 1fr;\n    place-items: center;\n    width: 100%;\n}\n\n.ri-icon{\n    font-size: 30px;\n}\n\n.iconPara p{\n    font-size: 12px;\n    margin-bottom: -2px;\n}\n\n.iconPara{\n    margin-top: 30px;\n}\n\n.iconPara2{\n    margin-top: 0px;\n}\n\n.empty{\n    width: 100%;\n    height: 10px;\n    border-radius: 10px;\n    background-color: #3C4554;\n    margin-top: 2%;\n}\n\n.missed{\n    background-color: #3C4554;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 40px;\n    width: 100%;\n    padding: 0 10px;\n    margin-top: 5%;\n    border-radius: 10px;\n}\n\n.area-top2{\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    margin-top: 8px;\n    background-color: #3C4554;\n    border-radius: 10px;\n}\n\n.missed p{\n    margin-top: 4%;\n}\n\n.iconPara2 p{\n    margin-bottom: -2px;\n}\n\n.area-top{\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    margin-top: 20px;\n    background-color: #3C4554;\n    border-radius: 10px;\n}\n\n.area-bottom{\n    display: flex;\n    justify-content: space-around;\n    margin-top: 2%;\n}\n\n.len{\n    margin-top: 2%;\n    width: 100%;\n    height: 100px;\n}\n\n.btn-col{\n    background-color: #636C7B;\n}\n\n\n.LookUp{\n    margin-right: 20px;\n    font-size: 20px;\n}\n\n\n\n\n.goloc{\n    font-size: 13px;\n    margin-top: -5px;\n}\n\n\n.goloc2{\n    font-size: 12.5px;\n    margin-top: -4px;\n}\n\n.goloc3{\n    font-size: 20px;\n}\n\n.zero1{\n    font-size: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
